export const SENSITIVE_GENERAL_INTERACTION_HINT_TEXT = [
  'These notes can only be seen by users within your organization.',
].join(' ');

export const SENSITIVE_GENERAL_NOTE_HINT_TEXT = [
  'These notes are visible to all other platform users working with the client',
  'and help communicate updates to users outside of your organization.',
].join(' ');
